import { useEffect, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import styles from "../../../layout/admin/Main.module.scss";
//専用コンポーネント
import SearchForm from "./PublisherSearchFrom";
//共通コンポーネント
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import DataTable from "../../../features/DataTable";
import Button from "../../../ui/Button";
import CSVDownloader from "../../../ui/CSVDownloader";
import DetailTable from "../../../../components/ui/AdminDetailTable";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
//API
import {
  getNoticeDetail,
  getPublisherList,
} from "../../../../services/apiNotification";

const displayTypeNotice = 1; //画面モード_学生詳細
const displayTypePublisher = 2; //画面モード_申込講座
//定数；公開先選択
const publishedStudents = 2;
const publishedApplicant = 3;
//定数；メール配信フラグ
const is_email_true = 1;

const StudentDetail = () => {
  //画面モード
  const [displaytype, changeDisplayType] = useState(displayTypeNotice);
  //お知らせID
  const { noticeId } = useParams();
  /*お知らせ詳細*/
  //表示お知らせデータ
  const [noticeInfoElements, SetNoticeInfoElements] = useState([]);
  const [noticePublished, SetNoticePublished] = useState([]); //公開先区分ID
  // ローディング表示
  const [loading, setLoading] = useState(false);
  /*公開者一覧*/
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 公開者一覧データ
  const [tableData, setTableData] = useState([]);
  const [tableMeata, setTableMeata] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  const tableResetRef = useRef();
  // CSVダウンロードデータ
  const [csvData, setCsvData] = useState({});
  const navigate = useNavigate();

  const getLinkElement = (url) => {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {url}
      </a>
    );
  };

  //お知らせデータ表示
  const setStudentInfoElementsFunc = (data) => {
    const result = [
      { label: "お知らせID", value: data.id },
      { label: "カテゴリー", value: data.category_name },
      { label: "件名", value: data.title },
      { label: "日付", value: data.created_at },
      { label: "内容", value: data.content },
      { label: "ご参考URL 1", value: getLinkElement(data.refarence_url1) },
      { label: "ご参考URL 2", value: getLinkElement(data.refarence_url2) },
      { label: "ご参考URL 3", value: getLinkElement(data.refarence_url3) },
      { label: "備考", value: data.remarks },
      { label: "掲載期間(From)", value: data.period_from_str },
      { label: "掲載期間(To)", value: data.period_to_str },
      { label: "公開", value: data.is_control_text },
      { label: "公開先", value: data.published_to_text },
    ];
    //公開先で表示項目が分岐
    if (data.published_to === publishedStudents) {
      result.push({ label: "期生ID", value: data.generation_id });
    } else if (data.published_to === publishedApplicant) {
      result.push({ label: "講座ID", value: data.course_id });
      result.push({ label: "当選状況", value: data.lottery_status_text });
    }
    result.push({
      label: "お知らせメール",
      value: data.is_email === is_email_true ? "配信する" : "配信しない",
    });
    return result;
  };

  //初回レンダリング
  useEffect(() => {
    (async function () {
      // ローディング表示開始
      setLoading(true);
      //お知らせ詳細情報をセット
      const nt_data = await getNoticeDetail(noticeId);
      if (Object.keys(nt_data).length === 0) {
        navigate("/admin/404");
        return;
      }
      SetNoticeInfoElements(setStudentInfoElementsFunc(nt_data));
      SetNoticePublished(nt_data.published_to);
      // ローディング表示終了
      setLoading(false);
    })();
  }, []); // 初回レンダリング

  //公開先の区分でテーブルの内容を変化
  useEffect(() => {
    if (noticePublished === publishedApplicant) {
      setTableMeata([
        { key: "student_id", label: "学生番号(8桁)" },
        { key: "name", label: "氏名" },
        { key: "name_kana", label: "フリガナ" },
        { key: "lottery_status", label: "当選状況" },
        { key: "read_time", label: "既読日時" },
      ]);
    } else {
      setTableMeata([
        { key: "student_id", label: "学生番号(8桁)" },
        { key: "name", label: "氏名" },
        { key: "name_kana", label: "フリガナ" },
        { key: "read_time", label: "既読日時" },
      ]);
    }
  }, [noticePublished]); //お知らせ詳細データ取得時

  //公開者一覧検索
  useEffect(() => {
    //検索結果のセット
    const tableDataMapFunc = (d) => {
      if (noticePublished === publishedApplicant) {
        return {
          key: d.id,
          login_id: (
            <Link to={"../../student/detail/" + d.id}>{d.login_id}</Link>
          ),
          name: d.name,
          name_kana: d.name_kana,
          lottery_status: d.lottery_status_text,
          read_time: d.read_time,
        };
      } else {
        return {
          key: d.id,
          login_id: (
            <Link to={"../../student/detail/" + d.id}>{d.login_id}</Link>
          ),
          name: d.name,
          name_kana: d.name_kana,
          read_time: d.read_time,
        };
      }
    };
    const tableSortDataMapFunc = (d) => {
      if (noticePublished === publishedApplicant) {
        return {
          key: d.id,
          login_id: d.login_id,
          name: d.name,
          name_kana: d.name_kana,
          lottery_status: d.lottery_status_text,
          read_time: d.read_time,
        };
      } else {
        return {
          key: d.id,
          login_id: d.login_id,
          name: d.name,
          name_kana: d.name_kana,
          read_time: d.read_time,
        };
      }
    };
    const csvDataMapFunc = (d) => {
      if (noticePublished === publishedApplicant) {
        return {
          "学生番号(8桁)": d.login_id,
          氏名: d.name,
          フリガナ: d.name_kana,
          当選状況: d.lottery_status_text,
          既読日時: d.read_time,
        };
      } else {
        return {
          "学生番号(8桁)": d.login_id,
          氏名: d.name,
          フリガナ: d.name_kana,
          既読日時: d.read_time,
        };
      }
    };

    (async function () {
      // 申込者一覧画面でない場合はなにもせずにreturn
      if (displaytype !== displayTypePublisher) return;

      const data = await getPublisherList(noticeId, searchCondition);
      if (!data) return;

      //検索結果を画面にセット
      setTableData(data.map(tableDataMapFunc));
      setTableSortData(data.map(tableSortDataMapFunc));
      setCsvData(data.map(csvDataMapFunc));

      //ページネーション・ソートをリセット
      tableResetRef.current?.click();
    })();
  }, [searchCondition]); //公開者一覧検索

  //画面切り替え時の処理
  useEffect(() => {
    //画面切り替え時に検索結果をリセットする
    if (displaytype === displayTypePublisher) {
      setSearchCondition({}); //全件取得
    }
  }, [displaytype]); //画面切り替え時の処理

  return (
    <div className={styles.main}>
      <ScreenTitle>お知らせ管理</ScreenTitle>
      <SubScreenTitle>お知らせ詳細</SubScreenTitle>
      <div className={styles.buttonbox__tab}>
        <Button
          type="tab"
          styleType={displaytype === displayTypeNotice ? "tab_active" : "tab"}
          onClick={() => changeDisplayType(displayTypeNotice)}
        >
          お知らせ詳細
        </Button>
        <Button
          type="tab"
          styleType={
            displaytype === displayTypePublisher ? "tab_active" : "tab"
          }
          onClick={() => changeDisplayType(displayTypePublisher)}
        >
          公開者一覧
        </Button>
      </div>
      {displaytype === displayTypeNotice ? (
        //学生詳細タブ
        <>
          <div className={styles.buttonbox__left}>
            <Link to={"../detail/update/" + noticeId}>
              <Button type="button" styleType="search">
                情報変更
              </Button>
            </Link>
          </div>
          <DetailTable elements={noticeInfoElements}></DetailTable>
          <div className={styles.buttonbox__left}>
            <Link to={"../detail/update/" + noticeId}>
              <Button type="button" styleType="search">
                情報変更
              </Button>
            </Link>
          </div>
        </>
      ) : (
        <></>
      )}
      {displaytype === displayTypePublisher ? (
        //申込講座詳細タブ
        <>
          <SearchForm setSearchCondition={setSearchCondition}></SearchForm>
          <DataTable
            tableData={tableData}
            tableMeata={tableMeata}
            tableSortData={tableSortData}
            tableResetRef={tableResetRef}
          ></DataTable>
          <CSVDownloader
            data={csvData}
            filenameprefix="公開者一覧"
            buttonname="ダウンロード"
          />
        </>
      ) : (
        <></>
      )}
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/notification">
          お知らせ管理へ戻る
        </Link>
      </div>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
      {loading ? <Loading /> : <></>}
      {loading ? <Progress /> : <></>}
    </div>
  );
};
export default StudentDetail;
